import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { buttonsStyle, dateFormatter, substringFormatter } from '../../../components/tables/table'
import { getTexts } from '../../../../api/text'
import { Button, Tooltip, Chip } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import { alertError } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'
import { getNonEmpty } from '../../../../utils/helpers'

// Obtener una etiqueta de apartado más amigable según la clave
function getSectionLabelFromKey (key) {
  if (!key || typeof key !== 'string') return 'Otros'

  // sobre-nosotros
  if ([
    'quienes_somos',
    'mercado_y_confianza',
    'comunidad_y_reputacion',
    'autenticidad_y_garantia',
    'sobre-nosotros-experiencia',
    'sobre-nosotros-ventas',
    'sobre-nosotros-garantia',
    'sobre-nosotros-valoraciones'
  ].includes(key)) {
    return 'sobre-nosotros'
  }

  // avisos
  if (key === 'aviso-legal' || key === 'politica-privacidad') {
    return 'avisos'
  }

  // instrucciones
  if (key === 'instrucciones_transferencia' || key === 'instrucciones_confirmacion_redsys') {
    return 'instrucciones'
  }

  // menus
  if (['banner-superior', 'titulo-portada', 'derechos-reservados'].includes(key)) {
    return 'menus'
  }

  return 'Otros'
}

function getData (texts) {
  let data = []
  for (let i = 0; i < texts.length; ++i) {
    const elem = {}
    elem.key = texts[i].key || ''
    elem.section = getSectionLabelFromKey(elem.key)
    elem.title = getNonEmpty(texts[i].title)
    elem.content = getNonEmpty(texts[i].content)
    elem.createdAt = texts[i].createdAt
    elem.id = texts[i]._id
    data = data.concat(elem)
  }
  return data
}

export default function TextsPage () {
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter (cell) {
    return (<>
      <Tooltip title='Edit'>
        <Button
          style={buttonsStyle} size='small'
          onClick={() => history.push('/edit-text/' + cell)}>
          <EditIcon />
        </Button>
      </Tooltip>
    </>)
  }

  const keyFormatter = (cell) => {
    if (!cell) return <span style={{ color: '#9ca3af' }}>—</span>
    return (
      <Chip
        label={cell}
        size='small'
        style={{ backgroundColor: '#e0f2fe', color: '#0369a1', fontFamily: 'monospace' }}
      />
    )
  }

  const columns = [
    { dataField: 'key', text: 'Clave', sort: true, formatter: keyFormatter, headerStyle: { width: '180px' } },
    { dataField: 'title', text: 'Título', sort: true },
    { dataField: 'content', text: 'Contenido', sort: true, formatter: substringFormatter },
    {
      dataField: 'createdAt',
      text: 'Creado',
      formatter: dateFormatter,
      sort: true
    },
    { dataField: 'id', text: '', formatter: buttonFormatter }
  ]

  useEffect(() => {
    getTexts().then((res) => {
      if (res.status === 200) {
        setData(getData(res.data))
        setRefresh(false)
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get texts.' })
    })
  }, [refresh])

  // Agrupar textos por apartado para mostrarlos en bloques separados
  const groupedBySection = data.reduce((acc, item) => {
    const section = item.section || 'Otros'
    if (!acc[section]) acc[section] = []
    acc[section].push(item)
    return acc
  }, {})

  const sectionOrder = ['sobre-nosotros', 'avisos', 'instrucciones', 'menus', 'Otros']

  const orderedSections = Object.keys(groupedBySection).sort((a, b) => {
    const ia = sectionOrder.indexOf(a)
    const ib = sectionOrder.indexOf(b)
    if (ia === -1 && ib === -1) return a.localeCompare(b)
    if (ia === -1) return 1
    if (ib === -1) return -1
    return ia - ib
  })

  return (
    <>
      <Card>
        <CardHeader title='Textos editables'>
        </CardHeader>
      </Card>

      {orderedSections.map((section) => (
        <Card key={section} className='mt-5'>
          <CardHeader title={section} />
          <CardBody>
            <Table
              data={groupedBySection[section]}
              columns={columns}
            />
          </CardBody>
        </Card>
      ))}
    </>
  )
}
